// extracted by mini-css-extract-plugin
export default {"approveBtn":"styles_approveBtn__VKj5T"};